import { createInstance } from '@/helpers/api/base'
import { useAppMutation } from '@/helpers/api/mutation'
import { ControlSheetAnnotationDTO } from '@/types/controlsheet'

interface ICreateDutyGeneralAnnotationRequest {
    dutyCode: string
    tripNumber: string
    runNumber: string
    route: string
}

export const useCreateGeneralAnnotation = () => {
    const createGeneralAnnotationMutation = useAppMutation<
        ControlSheetAnnotationDTO,
        Error,
        ICreateDutyGeneralAnnotationRequest
    >({
        mutationFn: (data) =>
            createInstance({
                url: `/duty-annotations/general`,
                method: 'POST',
                data,
            }),
        alertOnError: true,
    })

    const handleCreateGeneralAnnotationAsync = (
        dutyCode: string,
        tripNumber: string,
        runNumber: string,
        route: string
    ) =>
        createGeneralAnnotationMutation.mutateAsync({
            dutyCode,
            tripNumber,
            runNumber,
            route,
        })

    return {
        handleCreateGeneralAnnotationAsync,
        isPending: createGeneralAnnotationMutation.isPending,
        data: createGeneralAnnotationMutation.data,
        error: createGeneralAnnotationMutation.error,
    }
}
